module.exports = __webpack_public_path__ + "static/media/shape_4.c0077317.svg";